import { signUpSignInRoutes } from '@/router/routes/public.routes'
import routeHelpers from '@/router/routeHelpers'
import accountRoutes from '@/router/routes/account.routes'
import { INHEALTH_LOGO } from '@/constants/logosFileNames'
import { INHEALTH_THEME } from '@/constants/themes'
import { get360AppUrl } from '@/helpers/app.helpers'

export default function buildInhealthRoutes () {
	const INHEALTH_THEME_CSS = `${INHEALTH_THEME}-theme`

	const overrideMeta = {
		logo: { src: INHEALTH_LOGO },
		footer: { component: null },
		css: INHEALTH_THEME_CSS,
		showInstallAppButton: false,
		hideRightBackButton: true
	}

	let inhealthRoutes = [
		{
			path: '/',
			name: 'Inhealth',
			redirect: '/es/inicio-sesion'
		},
		...signUpSignInRoutes,
		// Redirect to 360.opensalud.es if the route is not found
		routeHelpers.buildRoutes('cuenta', accountRoutes),
	]

	inhealthRoutes.map((route) => {
		route.meta = { ...route.meta, ...overrideMeta }
		// If route has children, override meta for each child
		if (route.children) {
			route.children = route.children.map((childRoute) => {
				childRoute.meta = { ...childRoute.meta, ...overrideMeta }
				return childRoute
			})
		}
		return route
	})

	inhealthRoutes.push({
		path: '*',
		beforeEnter() {
			// Same path as the current one
			window.location.href = get360AppUrl(window.location.pathname.substring(1))
		}
	})

	return inhealthRoutes
}


// WEBPACK FOOTER //
// ./src/router/routes/inhealth.routes.js